import { Box, Flex } from 'reflexbox';
import styled, { useTheme } from 'styled-components';

import { Skeleton } from '@treams/treams-ui';

import Logo from 'assets/logo.svg';

const LineGradient = styled.div`
	width: 100%;
	height: 2px;
	background-image: ${(props) => props.theme.images.lineGradient};
`;

const Container = styled(Flex)`
	height: 80px;
	border-bottom: 1px solid ${(props) => props.theme.colors.lightBlue};
`;

const LogoContainer = styled(Box)`
	transition: 0.4s ease-out opacity;

	svg {
		display: block;
		width: 140px;
		height: 50px;
	}

	img {
		display: block;
		max-width: 140px;
		max-height: 40px;
		object-fit: contain;
		object-position: left center;
	}
`;

export default function ExternalMenu() {
	const theme = useTheme();

	return (
		<Box>
			<LineGradient />
			<Container p={3} alignItems="center">
				{theme.images.logo ? (
					<LogoContainer flexGrow={0} flexShrink={0}>
						{theme.images.logo.startsWith('/') ? (
							<Logo />
						) : (
							<img src={theme.images.logo} alt="Logo" />
						)}
					</LogoContainer>
				) : (
					<Skeleton.Box width={140} height={50} />
				)}
			</Container>
		</Box>
	);
}
